import { httpCreate } from './http';

const http = httpCreate('/srv/invitation-card');

export const invitationCard = {
	getList(activityId) {
		return http.get(`/pc/${activityId}`);
	},
	sort(activityId, id, sort) {
		return http.post(`/sort/${activityId}/${id}/${sort}`);
	},
	getSystemList(activityId) {
		return http.get(`/system/${activityId}`);
	},
	create(activityId, data) {
		return http.post(`/${activityId}`, data);
	},
	editor(id, data) {
		return http.put(`/${id}`, data);
	},
	updateUseStatus(id, status) {
		return http.post(`/useStatus/${id}/${status}`);
	},
	updatePreheatUseStatus(id, status) {
		return http.post(`/preheatUseStatus/${id}/${status}`);
	},
	deleteCard(id) {
		return http.delete(`/${id}`);
	},
	customMch(id) {
		return http.get(`/custom-mch/${id}`);
	},
	getPreheatLinkCardList(preheatId) {
		return http.get(`/preheat/${preheatId}`);
	},
};
